import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { PATIENT_LANGUAGES } from "../lib/patientLanguages";

export const PatientLanguageSelect = ({ value, onChange, disabled = false, testId, label = "Patient language" }) => (
  <div className="min-w-0 w-full max-w-xs">
    <label htmlFor={testId} className="text-xs text-slate-600">{label}</label>
    <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={testId} data-testid={testId} aria-label={label} className="w-full min-w-0 bg-white disabled:opacity-100 [&>span]:truncate">
        <SelectValue placeholder="Choose language" />
      </SelectTrigger>
      <SelectContent data-testid={`${testId}-options`} className="max-h-72 max-w-[calc(100vw-2rem)]">
        {PATIENT_LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`${testId}-option-${l.code}`}>
            {l.label}{l.code !== "en" ? ` · ${l.native}` : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);